import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { _throw } from 'rxjs/observable/throw';
import { VasAppFacade } from '../../vas/services/vas-app-facade.service';
import * as fromRoot from '../../vas/store/bootstrap';
import { NetworkStatus } from '../business-objects/network/network-status';
import * as actions from '../business-objects/network/network.actions';
import { IStatusResponse, VASRestService } from '../services/api/vas-rest';
import { Facade } from './facade';

export class NetworkFacade extends Facade {

    constructor(protected appFacade: VasAppFacade, protected api: VASRestService) {
        super(appFacade);
    }

    refreshStatusP(): Promise<IStatusResponse> {
        return new Promise((resolve, reject) => {
            this.refreshStatus$().toPromise().then(resolve, resolve);
        });
    }

    refreshStatus$(): Observable<IStatusResponse> {
        // tslint:disable-next-line:no-string-literal
        console.log(`refreshing status for ${this.api['host']}`);
        return this.api.simpleGet('/status')
            .take(1)
            // tslint:disable-next-line:no-object-literal-type-assertion
            .map<any, IStatusResponse>((response: Response) => ({
                ...response.json()
            } as IStatusResponse))
            .catch<any, IStatusResponse>((error: Response) => {

                switch (error.status) {
                    case 401: {
                        return this.api.simpleAnonymousGet('/status');
                    }
                    default: {
                        // tslint:disable-next-line:no-object-literal-type-assertion
                        return of({
                            authenticated: false,
                            ip: undefined
                        } as IStatusResponse);
                    }
                }
            })
            .do((status: IStatusResponse) => {
                this.appFacade.store.dispatch(new actions.SetOnlineAuthenticated(!!status.ip, status.authenticated));
            });
    }

    refreshStatus(): void {
        this.refreshStatus$().subscribe(() => true);
    }

    isOnline(): Observable<boolean> {

        if (this.appFacade.config.getOffLineMode()) {
            return of(false);
        }

        return this.appFacade.store.select((state: fromRoot.State) =>
            state.network.online
        );
    }

    isAuthenticated(): Observable<boolean> {
        return this.appFacade.store.select((state: fromRoot.State) => state.network.authenticated);
    }

    getNetworkStatus(): Observable<NetworkStatus> {
        return this.appFacade.store.select((state: fromRoot.State) => new NetworkStatus(state.network.online, state.network.authenticated));
    }

    isBusy(): Observable<boolean> {
        return this.api.busy$;
    }

    waitForNetwork(timeout: number = 10, retry: number = 5): Observable<any> {
        return this.api.simpleGet('/status')
            .retryWhen(response => {
                return response
                    .switchMap((error: Response) => {
                        switch (error.status) {
                            case 503: {
                                return of(error.status).delay(1000);
                            }
                            default: {
                                return _throw(error);
                            }
                        }
                    })
                    .take(5);
            })
            .catch(error => {
                switch (error.status) {
                    case 401: {
                        return this.api.simpleAnonymousGet('/status')
                            .catch(() => _throw(Error('Notwork not available')));
                    }
                    default: {
                        return _throw(error);
                    }
                }
            });
    }

    // keep this here for reference for now - will probably remove it later

    // refreshOnlineStatus(anonymous: boolean = false): Promise<IStatusResponse> {
    //
    //     if (this.config.getOffLineMode()) {
    //         return Promise.resolve(undefined);
    //     }
    //
    //     const subscription = anonymous ?
    //         this.http.get(this.r("/status")) :
    //         this.authHttp.get(this.r("/status"));
    //
    //     return new Promise((resolve, reject) => {
    //         subscription
    //             .timeout(5000)
    //             .subscribe(
    //                 (response: Response) => {
    //                     const r: IStatusResponse = response.json();
    //                     resolve(r);
    //                 },
    //                 (response: Response | DOMException) => {
    //                     switch (true) {
    //
    //                         case response instanceof DOMException: {
    //                             this.error((response as DOMException).toString());
    //                             break;
    //                         }
    //                         case (response as Response).status === 0: {
    //                             console.warn("OFFLINE");
    //                             break;
    //                         }
    //                         case (response as Response).status === 407: {
    //                             if (!this.proxyNotConfiguredNotificationShown) {
    //                                 this.proxyNotConfiguredNotificationShown = true;
    //                                 this.error("PROXY_NOT_CONFIGURED");
    //                             }
    //                             break;
    //                         }
    //                         default:
    //                             console.warn(response.toString());
    //                     }
    //                     resolve(response);
    //                 }
    //             );
    //     });
    // }
}



// WEBPACK FOOTER //
// ./src/core/facades/network-facade.ts